<template>
  <div>
    <h3>
      <b>{{ $t('FAQ.agenNaikKelas') }}</b>
    </h3>
    <hr />
    <h3>
      <b>21.1 Agen Naik Kelas melalui Aplikasi Mobile (iOS/Android)</b>
    </h3>
    <br />
    <ul>
      <li>
        Pilih tombol “Agen Naik Kelas” di halaman muka aplikasi Agen BeliRumah anda.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_78.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Lengkapi Progress Badge yang tersedia seperti Profil, Upload Foto, Biografi, dan unggah file
        Sertifikat Kompetensi Profesi Broker Properti Indonesia
        <div class="wrapper--img">
          <div class="d-flex justify-center align-center">
            <img
              src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_79.jpg"
              alt=""
              style="max-height: 500px; margin: 0 24px"
            />
            <img
              src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_80.jpg"
              alt=""
              style="max-height: 500px; margin: 0 24px"
            />
          </div>
        </div>
      </li>
      <br />
      <li>Setelah semua detail dipenuhi maka akan ada review dari tim BeliRumah.</li>
      <br />
      <li>
        Jika data yang disubmit di tolak, maka tim BeliRumah akan menginformasikan melalui halaman
        agen naik kelas.
      </li>
      <br />
      <li>
        Dan jika diapprove, maka tampilan halaman katalog listing dan listing card akan berubah
        dengan memunculkan badge “Agen Naik Kelas”
      </li>
    </ul>
    <hr />
    <h3>
      <b>21.2 Agen Naik Kelas melalui Browser Laptop/PC</b>
    </h3>
    <br />
    <ul>
      <li>
        Pilih tombol “Agen Naik Kelas” di halaman muka Menu Bar Agen BeliRumah anda.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/desktop/desktop_81_2.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Klik dan lengkapi Progress Badge Agen Naik Kelas yang tersedia seperti Profil, Upload Foto,
        Biografi, dan file Sertifikat Kompetensi Profesi Broker Properti Indonesia
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_82.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Setelah semua detail dipenuhi maka akan ada review dari tim BeliRumah.
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_83.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Jika data yang disubmit di tolak, maka tim BeliRumah akan menginformasikan melalui halaman
        agen naik kelas.
      </li>
      <br />
      <li>
        Dan jika diapprove, maka tampilan halaman katalog listing dan listing card akan berubah
        dengan memunculkan badge “Agen Naik Kelas”
      </li>
    </ul>
    <hr />
  </div>
</template>

<script>
export default {
  name: 'AgenNaikKelas',
};
</script>

<style></style>
